require('./home.less');


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/views/home/home.js
// module id = 0
// module chunks = 4